import React from 'react';
import { Input } from 'reactstrap';

import { formatCurrency } from 'utils/fuctions/formatCurrency';

const CurrencyMask = ({
  valueController,
  fieldName,
  value,
  shouldDisable = false,
  tabIndex = 0,
  autoFocus = false
}) => {
  const handleCurrencyChange = (event) => {
    const rawValue = event.target.value;

    const onlyNumbers = rawValue.replace(/\D/g, '');

    if (onlyNumbers === '') {
      valueController(fieldName, '');
      return;
    }

    const parsedValue = parseInt(onlyNumbers, 10);

    const formattedValue = formatCurrency(parsedValue, true);

    valueController(fieldName, formattedValue);
  };

  return (
    <Input
      tabIndex={tabIndex}
      type="text"
      name={fieldName}
      value={value}
      placeholder="R$ 0,00"
      disabled={shouldDisable}
      onChange={handleCurrencyChange}
      autoFocus={autoFocus}
    />
  );
};

export default CurrencyMask;
